import { businessConnectionMst, common } from '@libs/domain';
import { businessConnectionType, target } from '@libs/enums';
import { genMstColumns } from '@libs/templates/mst';
import type { Column } from '@ps-smart-cp/ppfw-client';
import type { BusinessConnectionMstRegistration } from '../models';
import { BusinessConnectionClassCell } from './BusinessConnectionClassCell';

const businessConnectionMstColumns: Column<BusinessConnectionMstRegistration>[] = [
  ...genMstColumns<BusinessConnectionMstRegistration>(),
  {
    displayName: businessConnectionMst.labelNames.businessConnectionClassSupplier,
    renderCell: ({ row, locale }) => (
      <BusinessConnectionClassCell
        benchmark={businessConnectionType.enum.supplier}
        businessConnectionClass={row.businessConnectionClass}
        locale={locale}
      />
    ),
  },
  {
    displayName: businessConnectionMst.labelNames.businessConnectionClassLentParty,
    renderCell: ({ row, locale }) => (
      <BusinessConnectionClassCell
        benchmark={businessConnectionType.enum.lentParty}
        businessConnectionClass={row.businessConnectionClass}
        locale={locale}
      />
    ),
  },
  {
    displayName: businessConnectionMst.labelNames.businessConnectionClassPayee,
    renderCell: ({ row, locale }) => (
      <BusinessConnectionClassCell
        benchmark={businessConnectionType.enum.payee}
        businessConnectionClass={row.businessConnectionClass}
        locale={locale}
      />
    ),
  },
  {
    displayName: businessConnectionMst.labelNames.businessConnectionClassBuyer,
    renderCell: ({ row, locale }) => (
      <BusinessConnectionClassCell
        benchmark={businessConnectionType.enum.buyer}
        businessConnectionClass={row.businessConnectionClass}
        locale={locale}
      />
    ),
  },
  {
    displayName: common.names.eligibleBillingProvider,
    renderCell: ({ row, locale }) =>
      target.toDisplay(row.eligibleBillingProvider ? target.enum.yes : target.enum.no, locale),
  },
];

export { businessConnectionMstColumns };
